// src/components/FeatureCard.tsx
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight } from 'lucide-react';

interface FeatureCardProps {
  title: string;
  description: string;
  imageSrc: string;
  link: string;
}

const FeatureCard = ({ title, description, imageSrc, link }: FeatureCardProps) => {
  return (
    <Link to={link} className="block h-full">
      <Card className="feature-card h-full hover:shadow-[0_0_15px_rgba(240,90,40,0.3)] hover:border-secondary transition-all duration-300 transform-none">
        <div className="relative h-48 overflow-hidden rounded-t-lg">
          <img
            src={imageSrc}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          />
        </div>
        <CardContent className="p-6">
          <h3 className="text-lg font-semibold mb-2 text-stone-800">{title}</h3>
          <p className="text-stone-600 mb-4">{description}</p>
          <div className="flex items-center text-secondary font-medium group">
            Preberi več <ArrowRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default FeatureCard;